import { tenantPath } from "helpers/tenant_path";
import { getHeaders } from "packs/client_app/config/request_headers";
import {
  GET_REFERRALS_PATH,
  JOB_APPLICATIONS_PATH,
  JOBS_PATH,
  SEND_MESSAGE_PATH,
} from "packs/organization_app/config";

export const getJobApplications = ({ limit, offset, jobId }) => {
  const query = `job_id=${jobId}&limit=${limit}&offset=${offset}`;

  return fetch(tenantPath(`${JOB_APPLICATIONS_PATH}?${query}`), {
    method: "GET",
    headers: getHeaders(),
  });
};

export const getJobs = ({ limit, offset }) => {
  const query = `limit=${limit}&offset=${offset}`;

  return fetch(tenantPath(`${JOBS_PATH}?${query}`), {
    method: "GET",
    headers: getHeaders(),
  });
};

export const getReferrals = ({ limit, offset }) => {
  const query = `limit=${limit}&offset=${offset}`;

  return fetch(tenantPath(`${GET_REFERRALS_PATH}?${query}`), {
    method: "GET",
    headers: getHeaders(),
  });
};

export const updateReferrals = ({ id, status }) => {
  return fetch(tenantPath(`${GET_REFERRALS_PATH}/${id}`), {
    method: "PUT",
    headers: getHeaders(),
    body: JSON.stringify({
      status,
    }),
  });
};
export const createReferrals = (formData: FormData) => {
  return fetch(tenantPath(`${GET_REFERRALS_PATH}`), {
    method: "POST",
    headers: {
      "X-CSRF-Token": document
        .querySelector("meta[name='csrf-token']")
        .getAttribute("content"),
    },
    body: formData,
  });
};

export const sendMessage = ({ message, application_ids }) => {
  return fetch(tenantPath(SEND_MESSAGE_PATH), {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify({
      message,
      application_ids,
    }),
  });
};
